module.exports = __webpack_public_path__ + "static/media/old-typical-phone_13936.83dac0ef.svg";